import * as fromDatatype from "../datatype-library/index";

export interface bl_wms_grn_fi_xtn_gendoc_line_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    wms_grn_hdr_guid: fromDatatype.GuidDataFieldInterface;
    wms_grn_line_guid: fromDatatype.GuidDataFieldInterface;
    date_wms_grn_hdr: fromDatatype.TimestampTzDatatypeInterface;
    date_wms_grn_line: fromDatatype.TimestampTzDatatypeInterface;
    xtn_gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
    date_xtn_gendoc_hdr: fromDatatype.TimestampTzDatatypeInterface;
    date_xtn_gendoc_line: fromDatatype.TimestampTzDatatypeInterface;
    guid_doc_event: fromDatatype.GuidDataFieldInterface;
    server_doc_type_wms_grn_hdr: fromDatatype.VarcharDatatypeInterface;
    server_doc_type_xtn_gendoc_hdr: fromDatatype.VarcharDatatypeInterface;
    server_doc_type_wms_grn_line: fromDatatype.VarcharDatatypeInterface;
    server_doc_type_xtn_gendoc_line: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    logic: fromDatatype.VarcharDatatypeInterface;
    option: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    quantity_contra: fromDatatype.NumericDatatypeInterface;
    quantity_signum: fromDatatype.NumericDatatypeInterface;
    amount_contra: fromDatatype.NumericDatatypeInterface;
    amount_signum: fromDatatype.NumericDatatypeInterface;
    serial_no: fromDatatype.JsonDatatypeInterface;
    batch_no: fromDatatype.JsonDatatypeInterface;
    bin_no: fromDatatype.JsonDatatypeInterface;
    log_json: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    split_qty: fromDatatype.NumericDatatypeInterface;
}

export class bl_wms_grn_fi_xtn_gendoc_line_link_RowClass
    implements bl_wms_grn_fi_xtn_gendoc_line_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    wms_grn_hdr_guid: fromDatatype.GuidDataFieldInterface;
    wms_grn_line_guid: fromDatatype.GuidDataFieldInterface;
    date_wms_grn_hdr: fromDatatype.TimestampTzDatatypeInterface;
    date_wms_grn_line: fromDatatype.TimestampTzDatatypeInterface;
    xtn_gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_gendoc_line_guid: fromDatatype.GuidDataFieldInterface;
    date_xtn_gendoc_hdr: fromDatatype.TimestampTzDatatypeInterface;
    date_xtn_gendoc_line: fromDatatype.TimestampTzDatatypeInterface;
    guid_doc_event: fromDatatype.GuidDataFieldInterface;
    server_doc_type_wms_grn_hdr: fromDatatype.VarcharDatatypeInterface;
    server_doc_type_xtn_gendoc_hdr: fromDatatype.VarcharDatatypeInterface;
    server_doc_type_wms_grn_line: fromDatatype.VarcharDatatypeInterface;
    server_doc_type_xtn_gendoc_line: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_01: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_02: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_03: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_04: fromDatatype.VarcharDatatypeInterface;
    client_doc_status_05: fromDatatype.VarcharDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    logic: fromDatatype.VarcharDatatypeInterface;
    option: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    quantity_contra: fromDatatype.NumericDatatypeInterface;
    quantity_signum: fromDatatype.NumericDatatypeInterface;
    amount_contra: fromDatatype.NumericDatatypeInterface;
    amount_signum: fromDatatype.NumericDatatypeInterface;
    serial_no: fromDatatype.JsonDatatypeInterface;
    batch_no: fromDatatype.JsonDatatypeInterface;
    bin_no: fromDatatype.JsonDatatypeInterface;
    log_json: fromDatatype.JsonDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    split_qty: fromDatatype.NumericDatatypeInterface;
}